import CoursePublicUnitsWrapper from "@components/Course/units/CoursePublicUnitsWrapper.vue"
import Vue from "vue"
import { v4 } from "uuid"

document.querySelectorAll("#units").forEach(unit => {
    const uuid = v4()
    unit.dataset.uuid = uuid

    const units = JSON.parse(unit.dataset.units)

    setTimeout(() => {
        new Vue({
            el: `#units[data-uuid='${uuid}']`,
            render: h =>
                h(CoursePublicUnitsWrapper, {
                    props: {
                        units,
                        noShadow: unit.dataset.noShadow
                    }
                })
        })
    })
})
